import { render, staticRenderFns } from "./miothreshold.vue?vue&type=template&id=95c25466&scoped=true&"
import script from "./miothreshold.vue?vue&type=script&lang=ts&"
export * from "./miothreshold.vue?vue&type=script&lang=ts&"
import style0 from "./miothreshold.vue?vue&type=style&index=0&id=95c25466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c25466",
  null
  
)

export default component.exports